import { ServiceTokens } from "$src/domain/ServiceTokens";
import { PagedResult } from "$src/domain/core/PagedResult";
import { CustomerSummary } from "$src/domain/customers/CustomerSummary";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class SearchCustomers {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, pattern: string, pageNumber: number, pageSize: number): Promise<PagedResult<CustomerSummary>> {
        return this.customerRepository.search(groupStoreId, pattern, pageNumber, pageSize);
    }
}

export const SearchCustomersToken = Symbol('SearchCustomersToken');    

